import { $$, requireElement } from '../../lib/dom';

/** FAQ accordion: one item open at a time. */
export function initAccordion(wrap: HTMLElement): void {
  const items = $$('.faq-item', wrap);
  const setOpen = (item: HTMLElement, open: boolean): void => {
    item.classList.toggle('open', open);
    requireElement('.faq-btn', item).setAttribute('aria-expanded', String(open));
  };
  items.forEach((item) => {
    requireElement('.faq-btn', item).addEventListener('click', () => {
      const willOpen = !item.classList.contains('open');
      items.forEach((other) => {
        setOpen(other, false);
      });
      setOpen(item, willOpen);
    });
  });
}
